
import React, { useEffect, useState } from "react";
import { Icon, Label, MessageBarType, PrimaryButton, Spinner, SpinnerSize } from "@fluentui/react";
import { connect } from "react-redux";
import { useTranslation } from "react-i18next";

// components
import PractitionerConceptItem from "./PractitionerConceptItem/PractitionerConcept.Item.Component";
import PractitionerProtocolConceptFormComponent from "../PractitionerProtocolConceptsForm/PractitionerProtocolConceptForm.Component";

// styles
import './PractitionerConcepts.List.Styles.css';

// functions
import * as ComponentFunctions from './PractitionerConcepts.List.Functions';

// models
import { ContractCommissionAgentConcept } from "../../../../models/Entities/Contracts/ContractCommissionAgentConcept";
import { MessageComponent } from "../../../../commons/component/MessageComponent";



const PractitionerConceptsListComponent = (props: ComponentFunctions.Props) => {

    const { t } = useTranslation();

    const [isOpenConceptPanel, setIsOpenConceptPanel] = useState(false);
    const openConceptPanel = () => setIsOpenConceptPanel(true);
    const dismissConceptPanel = () => setIsOpenConceptPanel(false);



    // useEffect(() => {
    //     props.GetAllContractCommissionAgents(props.ContractId);
    // }, [props.Agent === undefined]);

    useEffect(() => {
        props.Agent?.id && props.GetAllContractCommissionAgentConceptsByCommissionAgentId(props.Agent?.id, props.ContractId);
    }, [props.Agent?.id !== undefined]);

    useEffect(() => {
        if (props.SavingSuccessfully && isOpenConceptPanel) {
            dismissConceptPanel();
        }
    }, [props.SavingSuccessfully]);

    const concepts = props.Concepts ?? [];
    const conceptsCount = concepts.length;
    const isLoadingConcepts = props.isLoading && !props.LoadedSuccessfully;
    const hasConcepts = conceptsCount > 0;

    const Forms = (
        <>
            <PractitionerProtocolConceptFormComponent
                isOpen={isOpenConceptPanel}
                openPanel={openConceptPanel}
                dismissPanel={dismissConceptPanel}
                CommissionAgentId={props.CommissionAgentId}
                CommissionAgentConceptId={0}
                ContractId={props.ContractId}
            />
        </>
    )

    const DisabledInfo = props.disabled && (
        <MessageComponent
            message={t(
                'practitionerConcepts.disabledInfo',
                "Para especificar los conceptos a liquidar, debe deseleccionar el tilde de 'Contrato asociado'"
            )}
            type={MessageBarType.info}
        />
    );

    const EmptyState = (
        <div className="practitioner-concepts-empty-state">
            <Icon iconName="FilterSolid" className="practitioner-concepts-empty-icon" />
            <div className="practitioner-concepts-empty-title">
                {t('conceptList.noRegistries.noConceptsRegistered.noConceptsRegistered', 'No hay conceptos registrados')}
            </div>
            <div className="practitioner-concepts-empty-description">
                {props.emptyDescriptionText ??
                    t(
                        'practitionerConcepts.emptyDescription',
                        'Agregue conceptos para definir de forma clara la liquidacion del profesional en este protocolo.'
                    )}
            </div>
            {!props.disabled && (
                <PrimaryButton
                    iconProps={{ iconName: 'Add' }}
                    onClick={openConceptPanel}
                >
                    {t('conceptList.componentActions.addConcept', 'Agregar concepto')}
                </PrimaryButton>
            )}
        </div>
    );

    return (
        <div className="practitioner-concepts-card">
            <div className="practitioner-concepts-header">
                <div className="practitioner-concepts-heading">
                    <Label className="practitioner-concepts-title">
                        {t('contractDetailPage.contractDetailItem.conceptsSettled', 'Conceptos a liquidar')}
                    </Label>
                    <div className="practitioner-concepts-subtitle">
                        {props.subtitleText ??
                            t(
                                'practitionerConcepts.subtitle',
                                'Configure los conceptos coparticipables asociados al profesional para este contrato.'
                            )}
                    </div>
                </div>

                <div className="practitioner-concepts-actions">
                    <div className="practitioner-concepts-counter" aria-live="polite">
                        <span className="practitioner-concepts-counter-value">{conceptsCount}</span>
                        <span className="practitioner-concepts-counter-label">
                            {conceptsCount === 1
                                ? t('practitionerConcepts.counterSingle', 'concepto')
                                : t('practitionerConcepts.counterPlural', 'conceptos')}
                        </span>
                    </div>

                    <PrimaryButton
                        iconProps={{ iconName: 'Add' }}
                        onClick={openConceptPanel}
                        disabled={props.disabled}
                    >
                        {t('conceptList.componentActions.addConcept', 'Agregar concepto')}
                    </PrimaryButton>
                </div>
            </div>

            {DisabledInfo}

            {isLoadingConcepts ? (
                <div className="practitioner-concepts-loading-state">
                    <Spinner size={SpinnerSize.medium} />
                    <span>{t('conceptList.loading.loadingConcepts', 'Cargando conceptos...')}</span>
                </div>
            ) : hasConcepts ? (
                <div className="practitioner-concepts-list" role="list">
                    {concepts.map((concept: ContractCommissionAgentConcept) => (
                        <PractitionerConceptItem
                            key={concept.id}
                            disabled={props.disabled}
                            onClick={undefined}
                            CommissionAgentConcept={concept}
                        />
                    ))}
                </div>
            ) : (
                EmptyState
            )}

            {Forms}
        </div>
    );
};

export default connect(
    ComponentFunctions.mapStateToProps,
    ComponentFunctions.mapDispatchToProps
)(PractitionerConceptsListComponent as any);